var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"6","lg":"8"}},[_c('div',{staticClass:"d-flex align-center pb-0"},[_c('v-img',{attrs:{"max-width":_vm.widthLogoSeg,"src":_vm.logoSegurify}}),_c('h2',{staticClass:"ml-5"},[_vm._v("Pólizas")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }